export enum SCHEDULE_FILTER {
  UNDEFINED,
  EAGENDA,
  LEGISTATIVE,
  PANELS,
}
